import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable()
export class CredentialsResolver implements Resolve<any> {

    constructor(private config: ConfigService ) { }

    resolve() {
        return new Promise(resolve => {
            if(this.config.get('credentials')) {
                resolve(this.config.get('credentials'));
            } else {
                resolve({});
            }
        });
    }

}